//Created on behalf https://github.com/Frank13
import { surveyLocalization } from "../surveyStrings";

export var dutchSurveyStrings = {
  pagePrevText: "Vorige",
  pageNextText: "Volgende",
  completeText: "Verzenden",
  otherItemText: "Andere",
  progressText: "Pagina {0} van {1}",
  emptySurvey: "Er is geen zichtbare pagina of vraag in deze vragenlijst",
  completingSurvey: "Bedankt voor het invullen van de vragenlijst",
  loadingSurvey: "De vragenlijst is aan het laden...",
  optionsCaption: "Kies...",
  requiredError: "Gelieve een antwoord in te vullen",
  numericError: "Het antwoord moet een getal zijn",
  textMinLength: "Gelieve minsten {0} karakters in te vullen.",
  minSelectError: "Gelieve minimum {0} antwoorden te selecteren.",
  maxSelectError: "Gelieve niet meer dan {0} antwoorden te selecteren.",
  numericMinMax:
    "Uw antwoord '{0}' moet groter of gelijk zijn aan {1} en kleiner of gelijk aan {2}",
  numericMin: "Uw antwoord '{0}' moet groter of gelijk zijn aan {1}",
  numericMax: "Uw antwoord '{0}' moet groter of gelijk zijn aan {1}",
  invalidEmail: "Gelieve een geldig e-mailadres in te vullen.",
  exceedMaxSize: "De grootte van het bestand mag niet groter zijn dan {0}.",
  otherRequiredError: "Gelieve het veld 'Andere' in te vullen"
};

surveyLocalization.locales["nl"] = dutchSurveyStrings;
surveyLocalization.localeNames["nl"] = "nederlands";



// WEBPACK FOOTER //
// ./src/localization/dutch.ts